import AboutWrapper from "../../../components/About/AboutWrapper";

const About: React.FC = () => {
  return <AboutWrapper />; 
};

export default About;

